var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66662 19.75C7.25241 19.75 6.91662 19.4142 6.91662 19L6.91662 7.37067L4.86056 9.40308C4.56598 9.69427 4.09112 9.69153 3.79992 9.39694C3.50873 9.10236 3.51147 8.6275 3.80606 8.3363L7.17818 5.00296C7.32947 4.85342 7.5283 4.7814 7.72538 4.78662C7.92499 4.78165 8.12612 4.85592 8.27756 5.00913L11.6109 8.38126C11.9021 8.67584 11.8994 9.1507 11.6048 9.4419C11.3102 9.73309 10.8353 9.73035 10.5441 9.43576L8.41662 7.2835L8.41662 19C8.41662 19.4142 8.08083 19.75 7.66662 19.75Z",
    fill: "#8F95B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 19C19.75 19.4142 19.4142 19.75 19 19.75H17C16.5858 19.75 16.25 19.4142 16.25 19C16.25 18.5858 16.5858 18.25 17 18.25H19C19.4142 18.25 19.75 18.5858 19.75 19ZM19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H16C15.5858 12.75 15.25 12.4142 15.25 12C15.25 11.5858 15.5858 11.25 16 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12ZM19 5.75C19.4142 5.75 19.75 5.41421 19.75 5C19.75 4.58579 19.4142 4.25 19 4.25H14C13.5858 4.25 13.25 4.58579 13.25 5C13.25 5.41421 13.5858 5.75 14 5.75H19Z",
    fill: "#8F95B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDes);
export default __webpack_public_path__ + "static/media/sort-des.65032f48ede7823d983128513e085c79.svg";
export { ForwardRef as ReactComponent };